module.exports = __webpack_public_path__ + "static/section2-6a2a23a7d3c42b75442a1f81a64a1f9c.png";